import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Logging, DownloadingFile } from './LoadingComponent';
import { Control } from 'react-redux-form';
import { Button, Alert, Input } from 'reactstrap';
import { fetchFile } from '../redux/ActionCreators';
import { avail_files } from '../shared/data';
import { valid_url } from './Functions';

// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    file_dl:state.file_dl
  };
};

class Downloads extends Component {
    constructor(props){
      super(props);
      this.state = {
        loading_file:false,
        dl_mess:false,
        file_date_dl:(new Date()).toISOString().slice(0,10),
      };
      this.downloadFile = this.downloadFile.bind(this);
      this.onDismiss = this.onDismiss.bind(this);
    }
    downloadFile = async () => {
      if (this.props.file_dl!=''){
        this.setState({loading_file:true});
        let url = null;
        try{
          url = await fetchFile({
                        bucket:avail_files.filter(x=>x.name==this.props.file_dl)[0]['bucket'], 
                        key:avail_files.filter(x=>x.name==this.props.file_dl)[0]['key'].replace(/{year}/g, this.state.file_date_dl.slice(0,4)).replace(/{month}/g, this.state.file_date_dl.slice(5,7)).replace(/{day}/g, this.state.file_date_dl.slice(8,10)), 
                        sep:avail_files.filter(x=>x.name==this.props.file_dl)[0]['sep'], 
                        res_url:true
                      })
                      .then(res=>res.json());
        }catch(error){
          this.setState({dl_mess:true}); 
        }
        if(url==null || !valid_url(url)){
          this.setState({dl_mess:true});
        }else{
          window.location.replace(url);
        }
        this.setState({loading_file:false});
      }
    }

    onDismiss() {
      this.setState({dl_mess:false});
    }
    render(){
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else {
        return(
            <div className='container'>
              <div className="row justify-content-center">
                  <div className="col-6 m-5">
                      <h4> Autogestión de Reportes </h4>
                  </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-3">
                  <Control.select model="file_dl" type="select"
                      className="form-control"
                      updateOn='blur'
                      >
                      {[<option key={0} value={''}></option>].concat(avail_files.map((x,i)=>{
                          return(
                              <option key={i+1} value={x.name}>{x.name}</option>
                          );
                      }))}
                  </Control.select>
                </div>
                {/*
                <div className="col-3">
                  <Input 
                    type="date" 
                    value={this.state.file_date_dl} 
                    onChange={(e)=>this.setState({'file_date_dl':e.target.value})}
                    placeholder="Fecha..."
                  >
                  </Input>
                </div>
                */                  
                }
              </div>
              <div className="row align-items-center">
                <div className="col-12 mt-4">
                  <Button 
                    className="btn-corp"
                    onClick={this.downloadFile}
                    >
                      {this.state.loading_file ? <DownloadingFile/> : <small>Descargar Datos &darr;</small>}
                  </Button>
                </div>
              </div>
              <div className='row justify-content-center'>
                <div className='col-8 m-3'>
                  <Alert color="danger" isOpen={this.state.dl_mess} toggle={this.onDismiss}>
                    No se descargó. Intente de nuevo o consulte con el equipo de quantIM.
                  </Alert>
                </div>
              </div>
            </div>
        );
      }
    }
}

export default connect(mapStateToProps)(Downloads);
